import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';
import { Actions, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { getFilterPanelState } from 'search/reducers/root.reducer';
import { select, Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { DiscoverV2BffService } from '../../../elements-v2/service/discover-v2-bff.service';
import { searchChanged, setFilterPanelExpanded } from 'search/actions/search.actions';

@Component({
  selector: 'app-search-root',
  templateUrl: './search-root.component.html',
  styleUrls: ['./search-root.component.scss'],
})
export class SearchRootComponent implements OnInit, OnDestroy {
  @ViewChild('main', {static: true}) public main: ElementRef;
  public isSidebarExpanded: boolean;
  public isSidebarInFullscreen: boolean;
  private subscriptions: Subscription = new Subscription();
  public isKidsCatalog: boolean = false;
  public query: string = '';

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    public readonly translateService: TranslateService,
    private discoverV2BffService: DiscoverV2BffService,
    private readonly route: ActivatedRoute,
  ) {

  }

  public handleFilterPanelDispatch() {
    if (this.query && this.isKidsCatalog) {
        this.store.dispatch(setFilterPanelExpanded({expanded: false}));
    } else {
        this.store.dispatch(setFilterPanelExpanded({expanded: true}));
    }
  }

  public ngOnInit() {
    this.subscriptions.add(this.store.pipe(select(getFilterPanelState)).subscribe((filteringPanelState) => {
      this.isSidebarInFullscreen = filteringPanelState.fullscreen;
      this.isSidebarExpanded = filteringPanelState.expanded;
    }));

    this.subscriptions.add(
      combineLatest([
        this.route.queryParams,
        this.discoverV2BffService.$page,
      ]).subscribe(([params, page]) => {
        this.query = params.query;
        if (page?.settings) {
          this.isKidsCatalog = page.settings.audience.isKidsCatalog;
        }
        this.handleFilterPanelDispatch();
    }));

    this.subscriptions.add(this.actions$.pipe(
      ofType(searchChanged),
    ).subscribe(() => {
      this.main.nativeElement.focus();
    }));

  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
